module.exports = __webpack_public_path__ + "static/1179985039.54898792.jpg";